module.exports = __webpack_public_path__ + "media/flags/bm-b66fbda5.svg";